<div class="inbox-header">
	<div class="page-title d-inline">Inbox</div>
	<div class="d-flex float-right gap-2">
		<cv-multiselect
			[options]="queues"
			[values]="selectedQueues"
			[optionText]="'name'"
			[optionValue]="'id'"
			[placeholder]="'Select queue'"
			(valuesChange)="handleQueueChange($event)"
			*ngIf="shouldDisplayQueues()"
		>
		</cv-multiselect>

		<button
			class="btn btn-sm cv-btn-light"
			title="Refresh Inbox"
			(click)="reloadInbox()">
			<i class="fa fa-sync-alt"></i>
			<span>Update list</span>
		</button>
	</div>
</div>
